import { SETUP_CUSTOM_DOMAIN, SETUP_CUSTOMER_PORTAL } from "./action"

const initialState = {}

export const customerPortalReducer = (state = initialState, action) => {
    switch (action.type) {
        case SETUP_CUSTOMER_PORTAL:
            return {
                ...state, 
                ...action.payload
            }
        case SETUP_CUSTOM_DOMAIN: {
            const { smId, data } = action.payload;
            const currentDomainState = state[smId]?.custom_domain || {};
            return {
                ...state,
                [smId]: {
                    ...state[smId],
                    custom_domain: {
                        ...currentDomainState,
                        ...data
                    }
                }
            };
        }

        default:
            return state
    }
}